module.exports = __webpack_public_path__ + "img/Robert_Zhao.1de0eef6.png";